export default __webpack_public_path__ + "static/media/netlify-logo.603ef81c.png";